import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];
  static values = {
    checkboxName: String,
    tickIfContent: Boolean,
  };

  connect() {
    this.input = this.findCheckbox();
    if (!this.input) {
      console.warn("[toggle-content] Checkbox input not found. Looking for input[type=checkbox][name=%s].", this.checkboxNameValue);
      return;
    }

    if (this.tickIfContentValue && !this.input.checked && this.contentHasValue()) {
      this.input.checked = true;
    }

    this._onChange = () => this.sync();
    this.input.addEventListener("change", this._onChange);

    this.sync();
  }

  contentHasValue() {
    return this.contentTargets.some((el) =>
      Array.from(el.querySelectorAll('textarea, input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])'))
        .some((f) => f.value && f.value.trim() !== ""),
    );
  }

  disconnect() {
    if (this.input && this._onChange) {
      this.input.removeEventListener("change", this._onChange);
    }
  }

  toggle() {
    this.sync();
  }

  sync() {
    const checked = !!this.input?.checked;

    this.contentTargets.forEach((el) => {
      if (checked) {
        el.classList.remove("hidden", "opacity-0");
        el.classList.add("opacity-100", "flex");
        el.setAttribute("aria-hidden", "false");
      } else {
        el.classList.add("opacity-0");
        el.classList.remove("flex");
        el.classList.add("hidden");
        el.setAttribute("aria-hidden", "true");
      }

      el.querySelectorAll("input, select, textarea, button").forEach((f) => {
        f.disabled = !checked && f.name !== this.checkboxNameValue;
      });
    });
  }

  findCheckbox() {
    let input = this.element.querySelector(`input[type="checkbox"][name="${this.checkboxNameValue}"]`);
    if (input) return input;

    input = this.element.querySelector(`#${this.checkboxNameValue}[type="checkbox"]`);
    if (input) return input;

    return this.element.querySelector(`input[type="checkbox"]`);
  }
}
